import React from 'react'
import FastAccess from './fastAccess'
import HeaderLogo from './headerLogo'
import RouterCard from './routerCard'
import AsideFooter from './asideFooter'
import styles from './index.module.less'

export default ({ domRef }) => {
  return <div className={styles['home-aside']} ref={domRef}>
    <HeaderLogo />
    <div className="scroll-container">
      <RouterCard />
      <div style={{ height: 1, width: '100%', background: 'var(--m-line-1)', margin: '12px 0' }} />
      <FastAccess />
    </div>
    <AsideFooter />
  </div>
}
